import { InjectionToken, NgModule, Optional, SkipSelf, ɵɵdefineInjectable, ɵɵinject, Injectable, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpRequest, HttpEventType, HttpParams, HttpClient } from '@angular/common/http';
import { filter, map, mergeMap, share } from 'rxjs/operators';
import { defer, merge, of, EMPTY } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
const AirtableConfigToken = new InjectionToken('globalConfiguration');

class NgxAirtableModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('NgxAirtableModule is already loaded. Import it in the AppModule only');
        }
    }
    static forRoot(config) {
        return {
            ngModule: NgxAirtableModule,
            providers: [
                {
                    provide: AirtableConfigToken,
                    useValue: config
                }
            ]
        };
    }
}
NgxAirtableModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxAirtableModule });
NgxAirtableModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxAirtableModule_Factory(t) { return new (t || NgxAirtableModule)(ɵngcc0.ɵɵinject(NgxAirtableModule, 12)); }, imports: [[
            CommonModule
        ]] });
NgxAirtableModule.ctorParameters = () => [
    { type: NgxAirtableModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxAirtableModule, { imports: function () { return [CommonModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxAirtableModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ]
            }]
    }], function () { return [{ type: NgxAirtableModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

/**
 * Created by bohoffi on 30.05.2017.
 */
class RunAction {
    constructor(opts) {
        this._options = opts;
        this._http = this._options.base.airtable.http;
        this._endpointUrl = this._options.base.airtable.options.endpointUrl;
        this._apiVersion = this._options.base.airtable.options.apiVersion;
        this._baseId = this._options.base.baseId;
        this._path = this._options.path;
    }
    perform() {
        let request;
        switch (this._options.method) {
            case 'DELETE':
            case 'GET':
            case 'HEAD':
            case 'JSONP':
            case 'OPTIONS':
                request = new HttpRequest(this._options.method, `${this._endpointUrl}/v${this._apiVersion}/${this._baseId}/${this._path}`, {
                    params: this._options.params,
                    responseType: 'json'
                });
                break;
            case 'POST':
            case 'PUT':
            case 'PATCH':
                request = new HttpRequest(this._options.method, `${this._endpointUrl}/v${this._apiVersion}/${this._baseId}/${this._path}`, this._options.body, {
                    params: this._options.params,
                    responseType: 'json'
                });
                break;
        }
        return this._http.request(request)
            .pipe(filter((httpEvent) => httpEvent.type === HttpEventType.Response), map((response) => response.body));
    }
}

/**
 * Created by bohoffi on 30.05.2017.
 */
class Record {
    constructor(id, table) {
        this._id = id;
        this._table = table;
    }
    fetch() {
        return new RunAction({
            base: this._table.base,
            method: 'GET',
            path: `${this._table.urlEncodedNameOrId}/${this._id}`,
            params: new HttpParams({
                fromObject: {
                    api_key: this._table.base.airtable.options.apiKey
                }
            })
        }).perform();
    }
    patchUpdate(entityData) {
        return new RunAction({
            base: this._table.base,
            method: 'PATCH',
            path: `${this._table.urlEncodedNameOrId}/${this._id}`,
            params: new HttpParams({
                fromObject: {
                    api_key: this._table.base.airtable.options.apiKey
                }
            }),
            body: entityData
        })
            .perform();
    }
    putUpdate(entityData) {
        return new RunAction({
            base: this._table.base,
            method: 'PUT',
            path: `${this._table.urlEncodedNameOrId}/${this._id}`,
            params: new HttpParams({
                fromObject: {
                    api_key: this._table.base.airtable.options.apiKey
                }
            }),
            body: entityData
        })
            .perform();
    }
    destroy() {
        return new RunAction({
            base: this._table.base,
            method: 'DELETE',
            path: `${this._table.urlEncodedNameOrId}/${this._id}`,
            params: new HttpParams({
                fromObject: {
                    api_key: this._table.base.airtable.options.apiKey
                }
            })
        })
            .perform();
    }
}

const normalizeQueryParams = (params, additional) => {
    const normalizedParams = {};
    if (!!params.fields) {
        params.fields.forEach((fieldName, index) => {
            normalizedParams[`fields[${index}]`] = fieldName;
        });
    }
    if (!!params.filterByFormula) {
        normalizedParams.filterByFormula = params.filterByFormula;
    }
    if (!!params.maxRecords) {
        normalizedParams.maxRecords = params.maxRecords;
    }
    if (!!params.pageSize) {
        normalizedParams.pageSize = params.pageSize;
    }
    if (!!params.sort) {
        params.sort.forEach((sort, index) => {
            normalizedParams[`sort[${index}][field]`] = sort.field;
            normalizedParams[`sort[${index}][direction]`] = sort.direction;
        });
    }
    if (!!params.view) {
        normalizedParams.view = params.view;
    }
    if (!!additional) {
        Object.keys(additional).forEach((key) => {
            normalizedParams[key] = additional[key];
        });
    }
    return normalizedParams;
};

/**
 * Created by bohoffi on 30.05.2017.
 */
class Query {
    constructor(params, table) {
        this._params = params;
        this._table = table;
    }
    firstPage() {
        return new RunAction({
            base: this._table.base,
            method: 'GET',
            path: this._table.urlEncodedNameOrId,
            params: new HttpParams({
                fromObject: normalizeQueryParams(this._params, {
                    api_key: this._table.base.airtable.options.apiKey
                })
            })
        })
            .perform()
            .pipe(map(result => result.records));
    }
    eachPage() {
        return this._eachPage();
    }
    all() {
        return this._all();
    }
    _eachPage(offset, previous) {
        const additional = {
            api_key: this._table.base.airtable.options.apiKey
        };
        if (!!offset) {
            additional.offset = offset;
        }
        return defer(() => new RunAction({
            base: this._table.base,
            method: 'GET',
            path: this._table.urlEncodedNameOrId,
            params: new HttpParams({
                fromObject: normalizeQueryParams(this._params, additional)
            })
        })
            .perform()
            .pipe(mergeMap((result) => {
            const items$ = !!previous
                ? merge(previous, of(result.records))
                : of(result.records);
            const next$ = !!result.offset
                ? this._eachPage(result.offset, of(result.records))
                : EMPTY;
            return merge(items$, next$);
        })));
    }
    _all(offset, previous) {
        const additional = {
            api_key: this._table.base.airtable.options.apiKey
        };
        if (!!offset) {
            additional.offset = offset;
        }
        return defer(() => new RunAction({
            base: this._table.base,
            method: 'GET',
            path: this._table.urlEncodedNameOrId,
            params: new HttpParams({
                fromObject: normalizeQueryParams(this._params, additional)
            })
        })
            .perform()
            .pipe(mergeMap((result) => {
            const items$ = !!previous
                ? of(previous.concat(result.records))
                : of(result.records);
            const next$ = !!result.offset
                ? this._all(result.offset, result.records)
                : EMPTY;
            return merge(items$, next$);
        })));
    }
}

/**
 * Created by bohoffi on 30.05.2017.
 */
class Table {
    constructor(opts, base) {
        if (!opts.tableName && !opts.tableId) {
            throw new Error('Table name or table ID is required');
        }
        this._options = opts;
        this._base = base;
    }
    /**
     * Returns the record defined by the given id.
     */
    find(id) {
        return new Record(id, this).fetch();
    }
    /**
     * Creates a new Query instance with the given parameters.
     */
    select(params) {
        if (!params) {
            params = {};
        }
        return new Query(params, this);
    }
    /**
     * Creates a new record with the given data.
     */
    create(entityData) {
        return new RunAction({
            base: this.base,
            method: 'POST',
            path: this.urlEncodedNameOrId,
            params: new HttpParams({
                fromObject: {
                    api_key: this.base.airtable.options.apiKey
                }
            }),
            body: entityData
        })
            .perform();
    }
    /**
     * Updates a record defined by the given id with the given data.
     */
    update(id, entityData) {
        return new Record(id, this).patchUpdate(entityData);
    }
    /**
     * Deletes a record defined by the given id.
     */
    destroy(id) {
        return new Record(id, this).destroy();
    }
    /**
     * Replaces a record defined by the given id with the given data.
     */
    replace(id, entityData) {
        return new Record(id, this).putUpdate(entityData);
    }
    get options() {
        return this._options;
    }
    get base() {
        return this._base;
    }
    get urlEncodedNameOrId() {
        return this._options.tableId || encodeURIComponent(!!this._options.tableName ? this._options.tableName : '');
    }
}

class Base {
    constructor(baseId, airtable) {
        if (!baseId) {
            throw new Error('BaseId must be a non-empty string');
        }
        this._baseId = baseId;
        this._airtable = airtable;
    }
    table(tableOptions) {
        return new Table(tableOptions, this);
    }
    get baseId() {
        return this._baseId;
    }
    get airtable() {
        return this._airtable;
    }
}

/**
 * Created by bohoffi on 30.05.2017.
 */
const defaultOptions = {
    endpointUrl: 'https://api.airtable.com',
    apiVersion: 0
};
class Airtable {
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this._options = Object.assign(defaultOptions, this.config);
    }
    configure(opts) {
        this._options = Object.assign(this._options, opts);
        this._checkConfiguration();
        return this;
    }
    base(baseId) {
        this._checkConfiguration();
        return new Base(baseId, this);
    }
    get options() {
        return this._options;
    }
    _checkConfiguration() {
        if (!this._options.apiKey) {
            throw new Error('API key is required to connect to Airtable');
        }
    }
}
Airtable.ɵfac = function Airtable_Factory(t) { return new (t || Airtable)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(AirtableConfigToken)); };
Airtable.ɵprov = ɵɵdefineInjectable({ factory: function Airtable_Factory() { return new Airtable(ɵɵinject(HttpClient), ɵɵinject(AirtableConfigToken)); }, token: Airtable, providedIn: "root" });
Airtable.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [AirtableConfigToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(Airtable, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [AirtableConfigToken]
            }] }]; }, null); })();

/**
 * Created by bohoffi on 02.06.2017.
 */
const _extendLinked = (record, links, base) => {
    links.forEach((link) => {
        record[link.linkSelector] = base
            .table(link.target)
            .select({
            filterByFormula: link.linkFilter(record)
        })
            .all()
            .pipe(share());
    });
    return record;
};

class LinkedQuery extends Query {
    constructor(params, table, links) {
        super(params, table);
        this.table = table;
        this.links = links;
    }
    firstPage() {
        return super.firstPage()
            .pipe(map((records) => records.map(record => _extendLinked(record, this.links, this.table.base))));
    }
    eachPage() {
        return super.eachPage()
            .pipe(map((records) => records.map(record => _extendLinked(record, this.links, this.table.base))));
    }
    all() {
        return super.all()
            .pipe(map((records) => records.map(record => _extendLinked(record, this.links, this.table.base))));
    }
}

class LinkedTable extends Table {
    constructor(origin, links) {
        super(origin.options, origin.base);
        this.origin = origin;
        this.links = links;
    }
    static fromTable(origin, links) {
        return new LinkedTable(origin, links);
    }
    find(id) {
        return super.find(id)
            .pipe(map((record) => _extendLinked(record, this.links, this.origin.base)));
    }
    select(params) {
        if (!params) {
            params = {};
        }
        return new LinkedQuery(params, this.origin, this.links);
    }
    create(entityData) {
        throw new Error('LinkedTable is not able to create entities');
    }
    update(id, entityData) {
        throw new Error('LinkedTable is not able to update entities');
    }
    destroy(id) {
        throw new Error('LinkedTable is not able to destroy entities');
    }
    replace(id, entityData) {
        throw new Error('LinkedTable is not able to replace entities');
    }
}

/*
 * Public API Surface of ngx-airtable
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Airtable, Base, LinkedQuery, LinkedTable, NgxAirtableModule, Query, Table, AirtableConfigToken as ɵc };

//# sourceMappingURL=ngx-airtable.js.map